import React, { useState } from 'react';
import axios from 'axios';

const Chatbot = () => {
  const [messages, setMessages] = useState([
    { text: '¡Hola! Soy el asistente de Vanware. ¿En qué puedo ayudarte hoy? Te puedo ayudar a encontrar tu solucón, solo dime lo que necesites.', sender: 'bot', role: 'assistant' },
  ]);
  const [inputMessage, setInputMessage] = useState('');
  const changeStyle = (styleName) => {
    const themeLink = document.getElementById('theme-style');
    themeLink.parentNode.removeChild(themeLink); // Elimina la hoja de estilo actual
  
    const newLink = document.createElement('link');
    newLink.id = 'theme-style';
    newLink.rel = 'stylesheet';
    newLink.href = `/${styleName}`;
    document.head.appendChild(newLink); // Agrega la nueva hoja de estilo
  };
  

  const apiUrl = 'https://financial-chatbot-sobf.onrender.com/chat'; // Cambia la URL al endpoint de FastAPI

  const handleSendMessage = async () => {
    if (inputMessage.trim() !== '') {
      const newMessages = [...messages, { text: inputMessage, sender: 'user', role: 'user' }];
      setMessages(newMessages);
      setInputMessage('');

      try {
        const conversation = newMessages.map((message) => ({
          role: message.role,
          content: message.text,
        }));


        const response = await axios.post(apiUrl, { messages: conversation });

        if (response.status === 200) {
          const botResponse = response.data.response;
          setMessages((prevMessages) => [
            ...prevMessages,
            { text: botResponse, sender: 'bot', role: 'assistant' },
          ]);
        } else {
          console.error('Error en la API de FastAPI:', response.data.error);
          setMessages((prevMessages) => [
            ...prevMessages,
            { text: 'Error procesando tu solicitud.', sender: 'bot', role: 'assistant' },
          ]);
        }
      } catch (error) {
        console.error('Error llamando a la API de FastAPI:', error);
        setMessages((prevMessages) => [
          ...prevMessages,
          { text: 'Error procesando tu solicitud.', sender: 'bot', role: 'assistant' },
        ]);
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSendMessage();
    }
  };

  return (
    <div className="chat-container">
      <div className="style-tabs">
        <button onClick={() => changeStyle('Chatbot.css')}>Estilo 1</button>
        <button onClick={() => changeStyle('Chatbot2.css')}>Estilo 2</button>
        <button onClick={() => changeStyle('Chatbot3.css')}>Estilo 3</button>
      </div>

      <div className="chat-box">
        {messages.map((message, index) => (
          <div
            key={index}
            className={`chat-message ${message.sender === 'bot' ? 'bot-message' : 'user-message'}`}
          >
            {message.text.includes('```') ? (
              <div>{message.text.replace(/```/g, '')}</div>
            ) : (
              message.text
            )}
          </div>
        ))}
      </div>
      <div className="chat-input-container">
        <input
          type="text"
          className="chat-input"
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Escribe tu mensaje aquí..."
        />
        <button onClick={handleSendMessage} className="chat-send-btn">Enviar</button>
      </div>
    </div>
  );
};

export default Chatbot;
